<template>
  <el-form-item prop="variableArr" ref="formItem" verify :rules="variableArrRules" class="sky-server-config">
    <div
      :class="['sky-server-config__item', 'sk-font--B', isFill(item) && 'active']"
      v-for="(item, index) in variableArr"
      :key="index"
    >
      <i class="el-icon-arrow-right" />
      <el-select
        v-model="item.type"
        popper-class="sky-server-config__autocomplete"
        class="sky-server-config__select"
        filterable
      >
        <el-option v-for="(item, index) in serverElementList" :key="index" :label="$t(item.label)" :value="item.id">
        </el-option>
      </el-select>
      <i class="el-icon-arrow-right" />
      <el-select
        v-model="item.content"
        popper-class="sky-server-config__autocomplete"
        class="sky-server-config__select"
        filterable
      >
        <el-option v-for="(item, index) in valueList" :key="index" :label="$t(item.label)" :value="item.id">
        </el-option>
      </el-select>
      <i class="sk-icon-remove sk-font--B" v-if="index !== 0" @click="handleDelete(index)"></i>
    </div>

    <el-button type="primary" class="sky-branch-pattern__add" style="margin-top:5px" @click="handleAdd">
      添加
    </el-button>
  </el-form-item>
</template>
<script type="text/babel">
import { Select, Option, Input, Button } from 'element-ui'
import { action } from 'sky-engine/api'

import { CAL_SEGMENT_SCENE_MNG } from '@/api/apiModules'

export default {
  name: 'SkyCalServerElement',
  inject: ['rootView', 'elForm'],
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    [Button.name]: Button
  },
  props: {
    value: {
      type: [String, Array],
      default: ''
    }
  },
  data() {
    return {
      variableArr: [
        {
          type: null,
          content: null
        }
      ],
      loading: false,
      serverElementList: [],
      valueList: [
        {
          id: 'false',
          label: '否'
        },
        {
          id: 'true',
          label: '是'
        },
        {
          id: 'RESTORE',
          label: '还原桌面'
        },
        {
          id: 'SELFDOM',
          label: '个性桌面'
        },
        {
          id: 'NO_NEED',
          label: '无需渲染'
        },
        {
          id: 'LIGHT',
          label: 'AMD显卡可以满足'
        },
        {
          id: 'WEIGHT',
          label: '要求NVIDIA显卡'
        }
      ]
    }
  },
  mounted() {
    action(CAL_SEGMENT_SCENE_MNG, 'server/elements').then(response => {
      this.serverElementList = response.data.content.map(item => {
        return {
          id: item.id,
          label: item.label
        }
      })
      //this.value?.length && this.value[0]?.productId && this.handleFill(this.value)
    })
  },
  computed: {
    variableArrRules() {
      const validatorBranch = (rule, value, callback) => {
        let hasError = false
        if (this.variableArr.length) {
          for (const data of this.variableArr) {
            if (!this.isFill(data)) {
              hasError = true
              callback(new Error(this.$t('服务器元素类型或值不能为空')))
              break
            }
          }
        }
        if (this.isDuplicate()) {
          hasError = true
          callback(new Error(this.$t('服务器元素类型不能重复')))
        }
        if (!hasError) {
          callback()
        }
      }
      return [[{ validator: validatorBranch, trigger: ['blur', 'change'] }]]
    }
  },
  watch: {
    value(value) {
      if (this.value.length) {
        this.handleFill(value)
      }
    },
    variableArr: {
      handler: function(value) {
        this.$emit('input', value)
      },
      deep: true
    }
  },
  methods: {
    isFill(item) {
      return item.type && item.content !== null
    },
    isDuplicate() {
      if (this.variableArr.length) {
        const set = new Set()
        return this.variableArr.some(obj => {
          const combination = obj['type']
          if (set.has(combination)) {
            return true
          } else {
            set.add(combination)
          }
        })
      }
    },
    handleAdd() {
      this.variableArr.push({
        id: null,
        value: null
      })
    },
    handleFill(value) {
      this.variableArr = value
    },
    handleDelete(index) {
      this.variableArr.splice(index, 1)
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';

@include b(version-variable) {
  @include e(more-btn) {
    & .el-button {
      background-color: $--fill-base !important;
      color: $--color-primary !important;
      border: 0 !important;
      line-height: $--font-line-height-base - 0.2em;
      &:hover {
        color: $--color-primary-5 !important;
      }
    }
  }
}
@include b(server-config) {
  margin-bottom: 0px !important;
  @include e(autocomplete) {
    width: auto !important;
    min-width: 180px;
  }
  @include e(select) {
    width: 180px !important;
  }
  @include e(mutiple-select) {
    width: 300px !important;
  }
  @include e(item) {
    line-height: 30px;
    word-break: break-all;
    width: 1400px !important;
    color: $--disabled-color-base;
    &.active {
      color: $--color-primary;
    }
  }
  & i {
    margin-right: 5px;
  }
  & .el-input__inner {
    border-top: 0;
    border-left: 0;
    border-right: 0;
    padding: 0;
  }
  & .el-form-item__error {
    width: 500px !important;
  }
}
</style>
